<template>
  <div>
    <breadcrumb/>
    <PostList category="BBPP Productos y Servicios -  Línea de Crédito" />
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>